export default "__VITE_ASSET__CO7Z_og8__"